import GradingIcon from '@mui/icons-material/Grading';
import { ReactComponent as VisibilityIcon } from '@/assets/icons/viewOptions/voicon.svg';
import { ReactComponent as IndicationsIcon } from '@/assets/icons/tools/indications.svg';
import { type TabProps } from '@mui/material';
import { SvgIcon } from '@mui/material';
import { useMemo } from 'react';
import { useSurgerySpecificUiConfigValue } from '@/engine/app/modules/ui/useUiConfigValue';

type TabsData = Array<{ label: string; icon: TabProps['icon'] }>;

export const useTabsData = (): TabsData => {
  const labels = useSurgerySpecificUiConfigValue<Array<string>>('rightPanelTabLabels', [
    'Plan',
    'Objects',
    'Indications'
  ]);
  return useMemo(() => {
    return [
      { label: labels[0], icon: <GradingIcon /> },
      { label: labels[1], icon: <SvgIcon component={VisibilityIcon} inheritViewBox /> },
      { label: labels[2], icon: <SvgIcon component={IndicationsIcon} inheritViewBox /> }
    ];
  }, [labels]);
};
